import SliderTestimonials from "../modules/pricing-slider"

new SliderTestimonials()